module.exports = __webpack_public_path__ + "static/media/check-green.97d2b2ea.svg";